
import * as React from 'react';
import EditorProps from '../../components/editorinterface';
import Switch from 'react-ios-switch';
import { FormControl } from 'react-bootstrap';

interface Props extends EditorProps {

};

class BoolEditor extends React.Component<Props> {

	constructor(props: Props){
        super(props);
        this.onChange = this.onChange.bind(this);
    }

	public render() {
		var props = this.props;
		return (
		    <FormControl.Static>
    		    <Switch
    		        checked={props.value===null || props.value===undefined ? false : !!parseInt(props.value)}
    		        onChange={this.onChange}
    		    />
		    </FormControl.Static>
		);
	}

	private onChange() {
		let value = (this.props.value == 1) ? 0 : 1;
		this.props.onChange(this.props.field.id, value);
	}
}


export default BoolEditor;



// WEBPACK FOOTER //
// ./src/components/booleditor/index.tsx